import React from "react";
import DevicesTable from "./DevicesTable";

const Unassigned = () => {
  return <DevicesTable status="unassigned" />;
};

export default Unassigned;
